/// <reference types="@angular/localize" />

import { ErrorHandler } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

const bootstrapErrorHandler = new ErrorHandler();

bootstrapApplication(App, appConfig).catch((error: unknown) => {
  bootstrapErrorHandler.handleError(error);
});
